import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarInitialsComponent } from './avatar-initials.component';

@NgModule({
  declarations: [AvatarInitialsComponent],
  imports: [
    CommonModule
  ],
  exports: [AvatarInitialsComponent]
})
export class AvatarInitialsModule { }
